import { GenericLazyString } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import './TicketPrice.scss';

export interface TicketPriceProps {
    price: string | GenericLazyString | null;
    feesAndTaxes?: Array<string | GenericLazyString>;
    priceWithoutDiscounts: string | GenericLazyString | null;
    disabled: boolean;
}

const getFeesAndTaxesSeparator = <T,>(index: number, array: Array<T>) =>
    index < array.length - 1 ? ' / ' : null;

const TicketPrice: FunctionComponent<TicketPriceProps> = ({
    price,
    feesAndTaxes = [],
    priceWithoutDiscounts,
    disabled = false,
}) => {
    const priceWithoutDiscountsNode = priceWithoutDiscounts ? (
        <span
            className="eds-text--strikethrough ticket-price__without_discount eds-l-mar-left-2"
            data-testid="ticket-price__original-price"
        >
            {priceWithoutDiscounts}
        </span>
    ) : null;

    const feesAndTaxesComponentsNodes = feesAndTaxes.map(
        (formattedPrice, index, array) => (
            <span key={index} data-testid="ticket-price__fees__single-fee">
                {formattedPrice}
                {getFeesAndTaxesSeparator(index, array)}
            </span>
        ),
    );

    const feesAndTaxesNode = feesAndTaxesComponentsNodes.length ? (
        <span
            className="ticket-price__fees eds-text-color--ui-600 eds-l-mar-left-2"
            data-testid="ticket-price__fees"
        >
            {feesAndTaxesComponentsNodes}
        </span>
    ) : null;

    return (
        <div className="ticket-price__section" data-testid="ticket-price">
            <span
                className={classNames(
                    'ticket-price__price eds-text-weight--heavy',
                    {
                        'eds-text-color--ui-600': disabled,
                        'eds-text-color--ui-800': !disabled,
                    },
                )}
                data-testid="ticket-price__price"
            >
                {price}
                {priceWithoutDiscountsNode}
            </span>
            {feesAndTaxesNode}
        </div>
    );
};

export default TicketPrice;
